<template>
  <v-app id="inspire">
    <div class="da-page">
      <div class="da-page__glow da-page__glow--green"></div>
      <div class="da-page__glow da-page__glow--navy"></div>
      <div class="da-page__grid"></div>

      <button type="button" class="da-back" title="Retour à l'accueil" @click="$router.push({ path: '/' }).catch(() => {})">
        <v-icon color="#0c2461" size="20">mdi-arrow-left</v-icon>
        <span class="da-back__text">Retour à l'accueil</span>
      </button>

      <div class="da-card">
        <div class="da-card__head">
          <img src="../../assets/urbanGo.png" alt="urbanGo" height="56" />
          <h1 class="da-card__title">Inscrire ma compagnie</h1>
          <p class="da-card__subtitle">
            Remplissez ce formulaire pour la demande de votre adhésion. Les champs marqués d'un
            <span class="da-required">*</span> sont obligatoires.
          </p>
        </div>

        <form class="da-form" novalidate @submit.prevent="submitForm">
          <!-- ===== 1. COMPAGNIE ===== -->
          <div class="da-section">
            <div class="da-section__title"><span class="da-section__num">1</span>Votre compagnie</div>

            <div class="da-row">
              <div class="da-field da-col-full">
                <label for="da-designation" class="da-label">Référence de votre adhésion<span class="da-required">*</span></label>
                <input
                  id="da-designation"
                  v-model.trim="$v.compagnieTransport.designation.$model"
                  type="text"
                  class="form-control da-input"
                  :class="{ 'is-invalid': designationCompagnieErrors.length }"
                  placeholder="Référence de votre adhésion"
                  @blur="$v.compagnieTransport.designation.$touch()"
                />
                <div v-if="designationCompagnieErrors.length" class="da-error">{{ designationCompagnieErrors[0] }}</div>
              </div>

              <div class="da-field">
                <label for="da-raison" class="da-label">Raison sociale<span class="da-required">*</span></label>
                <input
                  id="da-raison"
                  v-model.trim="$v.compagnieTransport.raisonSociale.$model"
                  type="text"
                  class="form-control da-input"
                  :class="{ 'is-invalid': raisonSocialeCompagnieErrors.length }"
                  placeholder="Entrer une raison sociale"
                  @blur="$v.compagnieTransport.raisonSociale.$touch()"
                />
                <div v-if="raisonSocialeCompagnieErrors.length" class="da-error">{{ raisonSocialeCompagnieErrors[0] }}</div>
              </div>

              <div class="da-field">
                <label for="da-sigle" class="da-label">Sigle<span class="da-required">*</span></label>
                <input
                  id="da-sigle"
                  v-model.trim="$v.compagnieTransport.sigle.$model"
                  type="text"
                  class="form-control da-input"
                  :class="{ 'is-invalid': sigleCompagnieErrors.length }"
                  placeholder="Le sigle de la compagnie"
                  @blur="$v.compagnieTransport.sigle.$touch()"
                />
                <div v-if="sigleCompagnieErrors.length" class="da-error">{{ sigleCompagnieErrors[0] }}</div>
              </div>

              <div class="da-field da-col-full">
                <label for="da-description" class="da-label">Description<span class="da-required">*</span></label>
                <textarea
                  id="da-description"
                  v-model.trim="$v.compagnieTransport.description.$model"
                  class="form-control da-input da-textarea"
                  :class="{ 'is-invalid': descriptionCompagnieErrors.length }"
                  rows="3"
                  placeholder="Présentez votre compagnie en quelques mots"
                  @blur="$v.compagnieTransport.description.$touch()"
                ></textarea>
                <div v-if="descriptionCompagnieErrors.length" class="da-error">{{ descriptionCompagnieErrors[0] }}</div>
              </div>
            </div>
          </div>

          <!-- ===== 2. CONTACT ===== -->
          <div class="da-section">
            <div class="da-section__title"><span class="da-section__num">2</span>Contact et localisation</div>

            <div class="da-row">
              <div class="da-field da-col-full">
                <label for="da-email" class="da-label">E-mail de votre compagnie<span class="da-required">*</span></label>
                <input
                  id="da-email"
                  v-model.trim="$v.compagnieTransport.email.$model"
                  type="email"
                  class="form-control da-input"
                  :class="{ 'is-invalid': emailCompagnieErrors.length }"
                  placeholder="exemple@xyz.com"
                  autocomplete="email"
                  @blur="$v.compagnieTransport.email.$touch()"
                />
                <div v-if="emailCompagnieErrors.length" class="da-error">{{ emailCompagnieErrors[0] }}</div>
              </div>

              <div class="da-field">
                <label for="da-ville" class="da-label">Ville<span class="da-required">*</span></label>
                <select
                  id="da-ville"
                  v-model="$v.compagnieTransport.villeDesignation.$model"
                  class="form-select da-input da-select"
                  :class="{ 'is-invalid': villeCompagnieErrors.length }"
                  @blur="$v.compagnieTransport.villeDesignation.$touch()"
                >
                  <option :value="null" disabled>Où vous localiser ?</option>
                  <option v-for="(ville, i) in villesList" :key="i" :value="ville.designation">
                    {{ ville.designation }}
                  </option>
                </select>
                <div v-if="villeCompagnieErrors.length" class="da-error">{{ villeCompagnieErrors[0] }}</div>
              </div>

              <div class="da-field">
                <label for="da-telephone" class="da-label">N° de téléphone<span class="da-required">*</span></label>
                <div class="da-input-group">
                  <span class="da-input-prefix" :class="{ 'is-invalid': telephoneCompagnieErrors.length }">+225</span>
                  <input
                    id="da-telephone"
                    v-model.trim="$v.compagnieTransport.telephone.$model"
                    type="tel"
                    class="form-control da-input"
                    :class="{ 'is-invalid': telephoneCompagnieErrors.length }"
                    placeholder="XX XX XX XX XX"
                    autocomplete="tel"
                    @blur="$v.compagnieTransport.telephone.$touch()"
                  />
                </div>
                <div v-if="telephoneCompagnieErrors.length" class="da-error">{{ telephoneCompagnieErrors[0] }}</div>
              </div>
            </div>
          </div>

          <!-- ===== 3. DOCUMENTS ===== -->
          <div class="da-section">
            <div class="da-section__title">
              <span class="da-section__num">3</span>Documents à fournir
              <span class="da-section__opt">optionnel</span>
            </div>

            <div class="da-row">
              <div class="da-field">
                <span class="da-label">Logo de la compagnie</span>
                <div v-if="logoSelected" class="da-file da-file--filled">
                  <v-icon size="22" color="#159e72">mdi-image-outline</v-icon>
                  <div class="da-file__info">
                    <div class="da-file__name">{{ logoSelected.name }}</div>
                    <div class="da-file__size">{{ Math.max(1, Math.round(logoSelected.size / 1024)) }} Ko</div>
                  </div>
                  <button
                    type="button"
                    class="da-file__remove"
                    title="Retirer le fichier"
                    @click="logoSelected = null; $refs.logoInput.value = ''"
                  >
                    <v-icon size="18">mdi-close</v-icon>
                  </button>
                </div>
                <button v-else type="button" class="da-file" @click="$refs.logoInput.click()">
                  <v-icon size="22">mdi-image-plus</v-icon>
                  <span>Ajouter le logo <small>(image)</small></span>
                </button>
                <input
                  ref="logoInput"
                  type="file"
                  accept="image/*"
                  class="da-file__native"
                  @change="logoSelected = $event.target.files[0] || null"
                />
              </div>

              <div class="da-field">
                <span class="da-label">Attestation de transport</span>
                <div v-if="attestationSelected" class="da-file da-file--filled">
                  <v-icon size="22" color="#159e72">mdi-file-pdf-box</v-icon>
                  <div class="da-file__info">
                    <div class="da-file__name">{{ attestationSelected.name }}</div>
                    <div class="da-file__size">{{ Math.max(1, Math.round(attestationSelected.size / 1024)) }} Ko</div>
                  </div>
                  <button
                    type="button"
                    class="da-file__remove"
                    title="Retirer le fichier"
                    @click="attestationSelected = null; $refs.attestationInput.value = ''"
                  >
                    <v-icon size="18">mdi-close</v-icon>
                  </button>
                </div>
                <button v-else type="button" class="da-file" @click="$refs.attestationInput.click()">
                  <v-icon size="22">mdi-file-upload-outline</v-icon>
                  <span>Ajouter l'attestation <small>(PDF)</small></span>
                </button>
                <input
                  ref="attestationInput"
                  type="file"
                  accept="application/pdf"
                  class="da-file__native"
                  @change="attestationSelected = $event.target.files[0] || null"
                />
              </div>
            </div>
          </div>

          <button type="submit" class="da-submit" :disabled="isLoading">
            <span v-if="isLoading" class="da-spinner"></span>
            <span v-else>Demander votre adhésion</span>
          </button>
        </form>

        <div class="da-card__alt">
          Déjà inscrit ?
          <a href="#" @click.prevent="$router.push({ path: '/Login' }).catch(() => {})">Se connecter</a>
        </div>
      </div>

      <div class="da-copy">© {{ new Date().getFullYear() }} urbanGo. Tous droits réservés.</div>
    </div>

    <v-alert class="myalert alert-error" type="error" width="350px" dismissible>{{ errorMsg }}</v-alert>
    <v-overlay :value="overlay"><v-progress-circular indeterminate size="64"></v-progress-circular></v-overlay>
  </v-app>
</template>

<script>
import axios from "axios";
import {
  API_CREER_COMPAGNIE_TRANSPORT,
  API_OBTENIR_LISTE_DES_VILLES_DISPONIBLE,
} from "@/components/globalConfig/globalConstConfig";
import {
  required,
  minLength,
  maxLength,
  email,
} from "vuelidate/lib/validators";
import { showErrorMessage } from "../messages/messageProcess";
export default {
  name: "DemandeAdhesion",
  data() {
    return {
      successMsg: null,
      errorMsg: null,
      warningMsg: null,
      overlay: false,

      logoSelected: null,
      attestationSelected: null,

      isLoading: false,

      defaultObject: {},
      villesList: [],

      objectContainList: {
        datas: [],
      },

      compagnieTransport: {
        designation: null,
        description: null,
        raisonSociale: null,
        email: null,
        sigle: null,
        telephone: null,
        villeDesignation: null,
        documentDTOS: [],
      },

    };
  },

  validations: {
    compagnieTransport: {
      designation: {
        required,
        minLength: minLength(4),
        maxLength: maxLength(150),
      },

      description: {
        required,
        minLength: minLength(4),
        maxLength: maxLength(150),
      },

      email: {
        required,
        email,
      },

      raisonSociale: {
        required,
      },

      sigle: {
        required,
      },

      villeDesignation: {
        required,
      },

      telephone: {
        required,
      },
    },
  },

  methods: {
    reinitForm() {
      this.compagnieTransport.designation = null;
      this.compagnieTransport.description = null;
      this.compagnieTransport.email = null;
      this.compagnieTransport.raisonSociale = null;
      this.compagnieTransport.sigle = null;
      this.compagnieTransport.telephone = null;
      this.compagnieTransport.villeDesignation = null;
      this.compagnieTransport.documentDTOS = [];
      this.logoSelected = null;
      this.attestationSelected = null;
      this.$v.$reset();
    },

    // OBTENIR LA LISTE DES VILLES DISPONIBLES
    async obtenirListeVillesDispo() {
      await axios
        .post(API_OBTENIR_LISTE_DES_VILLES_DISPONIBLE, this.defaultObject, {
          headers: {
            server_id: "backend@africanb",
            client_id: "frontend@africanb",
          },
        })
        .then((response) => {
          this.villesList = response.data.items;
        })
        .catch((e) => {
          this.errorMsg = e;
          showErrorMessage();
        });
    },

    // LIT LE FICHIER ET RENVOIE SON CONTENU EN BASE64 (SANS LE PRÉFIXE "data:...;base64,")
    convertirEnBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result.split(",")[1]);
        reader.onerror = () => reject(reader.error);
        reader.readAsDataURL(file);
      });
    },

    // CONSTRUIT LE DOCUMENT À ENVOYER, UNE FOIS LE FICHIER ENTIÈREMENT LU
    async construireDocument(file, typeDocument) {
      return {
        compagnieTransportRaisonSociale: this.compagnieTransport.raisonSociale,
        typeDocument: typeDocument,
        content: await this.convertirEnBase64(file),
        typeMime: this.returnTypeMime(file),
      };
    },

    returnTypeMime(file) {
      var formatTypeMime = "";
      if (file.type == "image/png") {
        formatTypeMime = "FORMAT_PNG";
      }
      if (file.type == "image/jpeg") {
        formatTypeMime = "FORMAT_PNG";
      }
      if (file.type == "image/gif") {
        formatTypeMime = "FORMAT_GIF";
      }
      if (file.type == "application/pdf") {
        formatTypeMime = "FORMAT_PDF";
      }
      return formatTypeMime;
    },

    // SOUMETTRE LE FORMULAIRE
    submitForm() {
      this.$v.$touch();
      if (this.$v.compagnieTransport.$invalid) {
        this.errorMsg = "Des informations sont manquantes";
        showErrorMessage();
      } else {
        this.creerDemandeAdhesion();
      }
    },

    // CREATION D'UNE DEMANDE D'ADHESION
    async creerDemandeAdhesion() {
      this.isLoading = true;
      this.overlay = true;

      // Les fichiers doivent être entièrement lus avant l'envoi, sinon leur contenu part vide
      const documentDTOS = [];
      try {
        if (this.logoSelected) {
          documentDTOS.push(await this.construireDocument(this.logoSelected, "LOGO"));
        }
        if (this.attestationSelected) {
          documentDTOS.push(
            await this.construireDocument(this.attestationSelected, "ATTESTATION_TRANSPORT")
          );
        }
      } catch (e) {
        this.isLoading = false;
        this.overlay = false;
        this.$swal.fire(
          "Lecture du fichier impossible",
          "Vérifiez le logo et l'attestation, puis réessayez.",
          "error"
        );
        return;
      }

      // Un objet neuf à chaque envoi : une nouvelle soumission ne renvoie pas la précédente
      this.objectContainList.datas = [
        Object.assign({}, this.compagnieTransport, { documentDTOS }),
      ];
      let demandeEnregistree = false;
      await axios
        .post(API_CREER_COMPAGNIE_TRANSPORT, this.objectContainList, {
          headers: {
            server_id: "backend@africanb",
            client_id: "frontend@africanb",
            is_admin: "isAdmin",
          },
        })
        .then((response) => {
          if (response.status == 200) {
            if (response.data.status.code == 800) {
              this.successMsg = response.data.status.message;
              demandeEnregistree = true;
              this.$swal.fire(
                this.successMsg,
                "Votre demande a été prise en compte !",
                "success"
              );
            } else {
              this.errorMsg = response.data.status.message;
              this.$swal.fire(
                this.errorMsg,
                "Erreur lors la création de votre demande",
                "error"
              );
            }
          } else if (response.status == 204) {
            this.warningMsg = "Erreur , lors de la création";
            this.$swal.fire(
              this.warningMsg,
              "Erreur lors la création de votre demande",
              "warning"
            );
          } else {
            this.errorMsg = "Erreur , opération de création impossible";
            this.$swal.fire(
              this.errorMsg,
              "Erreur lors la création de votre demande",
              "error"
            );
          }
        })
        .catch((e) => {
          this.errorMsg = e;
          this.$swal.fire(
            this.errorMsg,
            "Erreur lors la création de votre demande",
            "error"
          );
        })
        .finally(() => {
          // En cas d'échec, la saisie est conservée pour pouvoir réessayer
          if (demandeEnregistree) {
            this.reinitForm();
          }
          this.objectContainList.datas = [];
          this.overlay = false;
          this.isLoading = false;
        });
    },
  },

  computed: {
    // GESTION DES CONTRAINTES DE CHAMPS D'ENTREES POUR LA CREATION D'UNE COMPAGNIE DE TRANSPORT

    designationCompagnieErrors() {
      const errors = [];
      if (!this.$v.compagnieTransport.designation.$dirty) return errors;
      !this.$v.compagnieTransport.designation.required &&
        errors.push("La désignation est obligatoire.");
      !this.$v.compagnieTransport.designation.minLength &&
        errors.push("La désignation doit avoir au minimum 4 caractères.");
      !this.$v.compagnieTransport.designation.maxLength &&
        errors.push("La désignation ne doit pas dépasser 150 caractères.");
      return errors;
    },

    descriptionCompagnieErrors() {
      const errors = [];
      if (!this.$v.compagnieTransport.description.$dirty) return errors;
      !this.$v.compagnieTransport.description.required &&
        errors.push("La description est obligatoire.");
      !this.$v.compagnieTransport.description.minLength &&
        errors.push("La description doit avoir au minimum 4 caractères.");
      !this.$v.compagnieTransport.description.maxLength &&
        errors.push("La description ne doit pas dépasser 150 caractères.");
      return errors;
    },

    raisonSocialeCompagnieErrors() {
      const errors = [];
      if (!this.$v.compagnieTransport.raisonSociale.$dirty) return errors;
      !this.$v.compagnieTransport.raisonSociale.required &&
        errors.push("La raison sociale est obligatoire.");
      return errors;
    },

    sigleCompagnieErrors() {
      const errors = [];
      if (!this.$v.compagnieTransport.sigle.$dirty) return errors;
      !this.$v.compagnieTransport.sigle.required &&
        errors.push("Le sigle est obligatoire.");
      return errors;
    },

    villeCompagnieErrors() {
      const errors = [];
      if (!this.$v.compagnieTransport.villeDesignation.$dirty) return errors;
      !this.$v.compagnieTransport.villeDesignation.required &&
        errors.push("La ville est obligatoire.");
      return errors;
    },

    telephoneCompagnieErrors() {
      const errors = [];
      if (!this.$v.compagnieTransport.telephone.$dirty) return errors;
      !this.$v.compagnieTransport.telephone.required &&
        errors.push("Le numéro de téléphone est obligatoire.");
      return errors;
    },
    emailCompagnieErrors() {
      const errors = [];
      if (!this.$v.compagnieTransport.email.$dirty) return errors;
      !this.$v.compagnieTransport.email.required &&
        errors.push("Le champ email est obligatoire");
      !this.$v.compagnieTransport.email.email && errors.push("Adresse e-mail invalide (ex : exemple@xyz.com).");
      return errors;
    },
  },

  mounted() {
    this.obtenirListeVillesDispo();
  },
};
</script>

<style lang="scss" scoped>
$green: #159e72;
$green-dark: #11845f;
$navy: #0c2461;
$ink: #0f172a;
$muted: #475569;
$subtle: #94a3b8;
$danger: #dc3545;
$line: rgba(15, 23, 42, 0.08);

@keyframes da-fade-up {
  from {
    opacity: 0;
    transform: translateY(16px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes da-spin {
  to {
    transform: rotate(360deg);
  }
}

.da-page {
  position: relative;
  min-height: 100vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 88px 16px 48px;
  font-family: "Montserrat", sans-serif;
  background: linear-gradient(180deg, #f3fbf8 0%, #ffffff 75%);

  button,
  input,
  select,
  textarea {
    font-family: "Montserrat", sans-serif;
  }
}

.da-page__glow {
  position: absolute;
  border-radius: 50%;
  filter: blur(80px);
  pointer-events: none;

  &--green {
    width: 520px;
    height: 520px;
    top: -200px;
    right: -140px;
    background: rgba(21, 158, 114, 0.22);
  }

  &--navy {
    width: 440px;
    height: 440px;
    bottom: -220px;
    left: -160px;
    background: rgba(12, 36, 97, 0.12);
  }
}

.da-page__grid {
  position: absolute;
  inset: 0;
  pointer-events: none;
  background-image: linear-gradient(rgba(12, 36, 97, 0.05) 1px, transparent 1px),
    linear-gradient(90deg, rgba(12, 36, 97, 0.05) 1px, transparent 1px);
  background-size: 48px 48px;
  -webkit-mask-image: radial-gradient(ellipse at 50% 30%, #000 0%, transparent 65%);
  mask-image: radial-gradient(ellipse at 50% 30%, #000 0%, transparent 65%);
}

/* RETOUR */
.da-back {
  position: absolute;
  top: 24px;
  left: 24px;
  z-index: 2;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 14px 8px 10px;
  font-size: 14px;
  font-weight: 700;
  color: $navy;
  background: #ffffff;
  border: 1px solid $line;
  border-radius: 999px;
  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.06);
  cursor: pointer;
  transition: transform 0.2s ease, border-color 0.2s ease;

  &:hover {
    transform: translateX(-2px);
    border-color: rgba(12, 36, 97, 0.25);
  }
}

/* CARTE */
.da-card {
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 720px;
  background: #ffffff;
  border: 1px solid $line;
  border-radius: 20px;
  padding: 40px 40px 32px;
  box-shadow: 0 30px 60px -16px rgba(12, 36, 97, 0.18), 0 12px 24px -10px rgba(12, 36, 97, 0.08);
  animation: da-fade-up 0.6s cubic-bezier(0.22, 1, 0.36, 1) both;
}

.da-card__head {
  text-align: center;
  margin-bottom: 28px;

  img {
    margin-bottom: 18px;
  }
}

.da-card__title {
  font-size: 26px;
  font-weight: 900;
  color: $navy;
  letter-spacing: -0.5px;
  margin-bottom: 6px;
}

.da-card__subtitle {
  max-width: 480px;
  margin: 0 auto;
  font-size: 14px;
  line-height: 1.6;
  color: $muted;
}

/* SECTIONS */
.da-section {
  padding: 22px 0;
  border-top: 1px solid $line;
}

.da-section__title {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 18px;
  font-size: 15px;
  font-weight: 800;
  color: $navy;
}

.da-section__num {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  font-size: 13px;
  font-weight: 800;
  color: #ffffff;
  background: $green;
}

.da-section__opt {
  font-size: 12px;
  font-weight: 600;
  color: $subtle;
}

.da-row {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
}

.da-col-full {
  grid-column: 1 / -1;
}

/* CHAMPS */
.da-field {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.da-label {
  margin-bottom: 7px;
  font-size: 13px;
  font-weight: 700;
  color: $ink;
}

.da-required {
  color: $danger;
  margin-left: 2px;
}

.da-input {
  height: 46px;
  font-size: 14px;
  color: $ink;
  background-color: #f8fafc;
  border: 1px solid rgba(15, 23, 42, 0.12);
  border-radius: 10px;
  transition: border-color 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease;

  &::placeholder {
    color: $subtle;
  }

  &:focus {
    background-color: #ffffff;
    border-color: $green;
    box-shadow: 0 0 0 3px rgba(21, 158, 114, 0.15);
  }

  &.is-invalid {
    border-color: $danger;

    &:focus {
      box-shadow: 0 0 0 3px rgba(220, 53, 69, 0.15);
    }
  }
}

.da-textarea {
  height: auto;
  min-height: 96px;
  padding-top: 12px;
  line-height: 1.5;
  resize: vertical;
}

.da-select {
  cursor: pointer;
}

.da-input-group {
  display: flex;

  .da-input {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
}

.da-input-prefix {
  display: flex;
  align-items: center;
  padding: 0 12px;
  font-size: 13px;
  font-weight: 700;
  color: $muted;
  background: #f1f5f9;
  border: 1px solid rgba(15, 23, 42, 0.12);
  border-right: none;
  border-radius: 10px 0 0 10px;

  &.is-invalid {
    border-color: $danger;
  }
}

.da-error {
  margin-top: 6px;
  font-size: 12px;
  font-weight: 600;
  color: $danger;
}

/* FICHIERS */
.da-file__native {
  display: none;
}

.da-file {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;
  min-height: 64px;
  padding: 12px 14px;
  font-size: 13px;
  font-weight: 700;
  color: $muted;
  background: #f8fafc;
  border: 1px dashed rgba(15, 23, 42, 0.2);
  border-radius: 10px;
  cursor: pointer;
  transition: border-color 0.2s ease, background 0.2s ease, color 0.2s ease;

  .v-icon {
    color: inherit !important;
  }

  small {
    font-weight: 600;
    color: $subtle;
  }

  &:hover {
    color: $green;
    border-color: $green;
    background: rgba(21, 158, 114, 0.04);
  }

  &--filled {
    justify-content: flex-start;
    cursor: default;
    background: #ffffff;
    border-style: solid;
    border-color: rgba(21, 158, 114, 0.35);

    &:hover {
      color: $muted;
      background: #ffffff;
      border-color: rgba(21, 158, 114, 0.35);
    }

    .v-icon {
      color: $green !important;
    }
  }
}

.da-file__info {
  flex: 1;
  min-width: 0;
  text-align: left;
}

.da-file__name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: $ink;
}

.da-file__size {
  font-size: 12px;
  font-weight: 600;
  color: $subtle;
}

.da-file__remove {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  flex-shrink: 0;
  border: 1px solid $line;
  border-radius: 8px;
  background: #ffffff;
  cursor: pointer;
  transition: border-color 0.2s ease, background 0.2s ease;

  .v-icon {
    color: $muted !important;
  }

  &:hover {
    border-color: rgba(220, 53, 69, 0.4);
    background: rgba(220, 53, 69, 0.06);

    .v-icon {
      color: $danger !important;
    }
  }
}

/* ENVOI */
.da-submit {
  width: 100%;
  height: 48px;
  margin-top: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  font-weight: 800;
  letter-spacing: 0.02em;
  color: #ffffff;
  border: none;
  border-radius: 12px;
  background: linear-gradient(135deg, $green 0%, $green-dark 100%);
  box-shadow: 0 8px 20px rgba(21, 158, 114, 0.28);
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease, opacity 0.2s ease;

  &:hover:not(:disabled) {
    transform: translateY(-1px);
    box-shadow: 0 12px 28px rgba(21, 158, 114, 0.38);
  }

  &:disabled {
    opacity: 0.75;
    cursor: wait;
  }
}

.da-spinner {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 2px solid rgba(255, 255, 255, 0.4);
  border-top-color: #ffffff;
  animation: da-spin 0.8s linear infinite;
}

.da-card__alt {
  margin-top: 24px;
  padding-top: 20px;
  border-top: 1px solid $line;
  text-align: center;
  font-size: 13px;
  color: $muted;

  a {
    font-weight: 700;
    color: $green;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
}

.da-copy {
  position: relative;
  z-index: 1;
  margin-top: 28px;
  font-size: 12px;
  color: $muted;
}

/* NOTIFICATION (jQuery fadeIn / fadeOut) */
.myalert {
  display: none;
  position: fixed !important;
  top: 24px;
  right: 24px;
  z-index: 1900;
  border-radius: 12px !important;
  font-family: "Montserrat", sans-serif;
  box-shadow: 0 16px 32px -8px rgba(15, 23, 42, 0.25) !important;
}

@media (max-width: 600px) {
  .da-page {
    padding-top: 80px;
  }

  .da-back {
    top: 16px;
    left: 16px;
    padding: 8px;
  }

  .da-back__text {
    display: none;
  }

  .da-card {
    padding: 32px 20px 26px;
    border-radius: 18px;
  }

  .da-card__title {
    font-size: 23px;
  }

  .da-row {
    grid-template-columns: 1fr;
  }

  .myalert {
    left: 16px;
    right: 16px;
    width: auto !important;
  }
}

@media (prefers-reduced-motion: reduce) {
  .da-card {
    animation: none;
  }
}
</style>
